/* splatky-karta.js — okno „i“ pri modrom boxe „Alebo na splátky za“ na karte tepelného čerpadla v kolekcii (snippets/splatky-karta.liquid).
 *
 * Pokyn Radovana 19. 10. 2026 (variant C): pri mesačnej splátke je malé „i“, ktoré otvorí reprezentatívny príklad s varovaním
 * „Pozor! Požičanie peňazí stojí peniaze.“ (reklama úveru, § 3 zákona 129/2010 Z. z., od 20. 11. 2026 § 5 zákona 312/2025 Z. z.).
 *
 * Nič tu nepočítame ani nepíšeme znova: čísla (KS) aj text príkladu (NB.tip) berie z assets/splatky-box.js (window.__csSplatkyBox), takže príklad v okne je na cent ten istý
 * ako začiatočný stav boxu „Alebo na splátky“ na stránke produktu. Parametre banky nesie box v atribúte data-par (rovnaký reťazec ako snippets/splatky-parametre.liquid:
 * sadzba|najmenej mesiacov|najviac mesiacov|najmenší úver €|najväčší úver €), cenu v centoch v data-cena. Bez splatky-box.js okno nevznikne a „i“ ostane obyčajným odkazom na novinku.
 * Udalosti sú delegované na dokument (karty sa doťahujú z ďalších strán kolekcie a filtre ich skrývajú), okno vzniká až pri prvom použití, žiadne id okrem okna.
 */
(function () {
  'use strict';
  if (window.__csSplatkyKarta) return;

  var CLANOK = '/blogs/novinky/tatra-banka-na-splatky';
  var tip = null, tipI = null, tipPin = false;

  var jeI = function (t) { return t && t.closest ? t.closest('[data-spl="i"]') : null; };

  /** parametre a cena z boxu, v ktorom je „i“; null, keď chýba skript boxu alebo údaje */
  function udaje(i) {
    var M = window.__csSplatkyBox, box = i.closest('.pcc-spl');
    if (!M || !M.KS || !M.NB || !box) return null;
    var p = String(box.getAttribute('data-par') || '').split('|'), cena = Number(box.getAttribute('data-cena'));
    var par = { sadzba: Number(p[0]), minMes: Number(p[1]), maxMes: Number(p[2]), minUver: Number(p[3]) * 100, maxUver: Number(p[4]) * 100 };
    if (!(cena > 0) || !(par.maxMes >= par.minMes) || isNaN(par.sadzba) || isNaN(par.minUver) || isNaN(par.maxUver)) return null;
    /* nulová akontácia, najdlhšia doba — ako v boxe na karte (najnižšia splátka) */
    var res = M.KS.vypocet({ cena: cena, vopred: 0, mes: par.maxMes }, par);
    return res.ok ? { M: M, par: par, res: res } : null;
  }
  function obsah(u) {
    return u.M.NB.tip(u.res, u.par, '') + '<p class="nb__poz">Úver poskytuje Tatra banka, a. s. <a href="' + CLANOK + '">Podmienky a ako to funguje →</a></p>';
  }

  function ukaz(i, pin) {
    var u = udaje(i);
    if (!u) return false;
    if (!tip) {
      tip = document.createElement('div'); tip.className = 'pcc-spl-tip'; tip.id = 'pcc-spl-tip'; tip.setAttribute('role', 'tooltip');
      document.body.appendChild(tip);
    }
    if (tipI && tipI !== i) tipI.removeAttribute('aria-describedby');
    tipI = i; tipPin = !!pin;
    tip.innerHTML = obsah(u); tip.style.display = 'block';
    i.setAttribute('aria-describedby', 'pcc-spl-tip');
    var b = i.getBoundingClientRect(), w = tip.offsetWidth, h = tip.offsetHeight;
    tip.style.left = Math.min(Math.max(8, b.left - 20), window.innerWidth - w - 8) + 'px';
    /* nad „i“, ak sa zmestí; inak pod ním; ak ani tak, okno sa zmenší výškou a posúva sa, aby „i“ nikdy nezakrylo */
    var nad = b.top - h - 8, pod = b.bottom + 8;
    var top = nad >= 8 ? nad : (pod + h <= window.innerHeight - 8 ? pod : 8);
    tip.style.maxHeight = Math.max(80, window.innerHeight - 16) + 'px';
    tip.style.top = Math.max(8, Math.min(top, window.innerHeight - Math.min(h, window.innerHeight - 16) - 8)) + 'px';
    return true;
  }
  function skry() {
    if (!tip) return;
    tip.style.display = 'none'; tipPin = false;
    if (tipI) tipI.removeAttribute('aria-describedby');
  }

  document.addEventListener('click', function (e) {
    var i = jeI(e.target);
    if (i) {
      if (!udaje(i)) return;                                  /* bez skriptu boxu ostáva obyčajný odkaz na novinku */
      e.preventDefault();
      if (tipPin && tipI === i && tip.style.display === 'block') skry(); else ukaz(i, true);
      return;
    }
    if (tip && tipPin) skry();
  });
  document.addEventListener('mouseover', function (e) { var i = jeI(e.target); if (i && !tipPin) ukaz(i, false); });
  document.addEventListener('mouseout', function (e) { if (jeI(e.target) && !tipPin) skry(); });
  document.addEventListener('focusin', function (e) { var i = jeI(e.target); if (i && !tipPin) ukaz(i, false); });
  document.addEventListener('focusout', function (e) { if (jeI(e.target) && !tipPin) skry(); });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') skry(); });
  window.addEventListener('scroll', function () { if (tip && tip.style.display === 'block') skry(); }, { passive: true });

  window.__csSplatkyKarta = true;
})();
